(function () {
  'use strict';

  angular.module('ringbaPortal.services').factory('targetGroupService', targetGroupService);

  function targetGroupService(
    $http,
    concurrencyMatrixService,
    statsService,
    ngAuthSettings
  ) {
    'ngInject';

    const serviceBaseUri = ngAuthSettings.apiServiceBaseUri;

    const columnSettings = {
      name: {
        class: 'column-sortable text-left',
        stSort: 'name',
        stSkipNatural: true,
        displayName: 'TARGET_GROUPS_NAME'
      },
      isSimalDial: {
        class: 'tablesort-sortable text-center',
        stSort: 'isSimalDial',
        displayName: 'TARGET_GROUPS_SIMULDIAL',
        rowAlign: 'center'
      },
      oSchedule: {
        class: 'tablesort-sortable text-left',
        stSort: 'oSchedule',
        displayName: 'TARGET_GROUPS_SCHEDULE_OVERRIDE'
      },
      oCapacity: {
        class: 'tablesort-sortable text-left',
        stSort: 'oCapacity',
        displayName: 'TARGET_GROUPS_CAPACITY_OVERRIDE'
      },
      oConcurrency: {
        class: 'tablesort-sortable text-left',
        stSort: 'oConcurrency',
        displayName: 'TARGET_GROUPS_CONCURRENCY_OVERRIDE'
      },
      numTargets: {
        class: 'column-sortable text-right',
        stSort: 'targets.length || 0',
        displayName: 'TARGET_GROUPS_TARGETS',
        stSkipNatural: true,
        rowAlign: 'right'
      },
      currentLive: {
        class: 'tablesort-sortable text-left',
        stSort: 'usageStats.currentLive',
        displayName: 'STATS_LIVE',
        rowAlign: 'left'
      },
      currentHour: {
        class: 'tablesort-sortable text-left',
        stSort: 'usageStats.currentHour',
        displayName: 'STATS_HOUR',
        rowAlign: 'left'
      },
      currentDay: {
        class: 'tablesort-sortable text-left',
        stSort: 'usageStats.currentDay',
        displayName: 'STATS_DAY',
        rowAlign: 'left'
      },
      currentMonth: {
        class: 'tablesort-sortable text-left',
        stSort: 'usageStats.currentMonth',
        displayName: 'STATS_MONTH',
        rowAlign: 'left'
      },
      total: {
        class: 'tablesort-sortable text-left',
        stSort: 'usageStats.total',
        displayName: 'STATS_TOTAL',
        rowAlign: 'left'
      },
      status: {
        class: 'tablesort-sortable text-center',
        stSort: 'status',
        displayName: 'STATUS_TEXT',
        rowAlign: 'center'
      },
      enabled: {
        class: 'column-sortable text-left',
        stSkipNatural: true,
        stSort: 'enabled',
        displayName: 'STATUS_TEXT'
      }
    };

    const defaultColumns = [
      'name',
      'isSimalDial',
      'oSchedule',
      'oCapacity',
      'oConcurrency',
      'numTargets',
      'currentLive',
      'currentHour',
      'currentDay',
      'currentMonth',
      'total',
      'status'
    ];

    
    const blockReasonTranslation = {
      'OPEN': {
        className: 'green_status',
        tooltip: 'TARGETS_STATUS_OPEN',
        status: 'open',
      },
      'CLOSED': {
        className: 'red_status',
        tooltip: 'TARGETS_STATUS_DISABLED',
        status: 'red-disabled',
      },
      'ConcurrencyHit': {
        className: 'yellow_status',
        tooltip: 'TARGETS_STATUS_CC_HIT',
        status: 'capped',
      },
      'GroupConcurrencyHit': {
        className: 'yellow_status',
        tooltip: 'TARGETS_STATUS_CC_HIT_GROUP',
        status: 'capped',
      },
      'IsCapped': {
        className: 'yellow_status',
        tooltip: 'TARGETS_STATUS_CAPPED',
        status: 'capped',
      },
      'GroupIsCapped': {
        className: 'yellow_status',
        tooltip: 'TARGETS_STATUS_CAPPED_GROUP',
        status: 'capped',
      },
      'IsClosed': {
        className: 'red_status',
        tooltip: 'TARGETS_STATUS_CLOSED',
        status: 'red-disabled',
      },
      'GroupIsClosed': {
        className: 'red_status',
        tooltip: 'TARGETS_STATUS_CLOSED_GROUP',
        status: 'red-disabled',
      },
      'Disabled': {
        className: 'red_status',
        tooltip: 'TARGETS_STATUS_DISABLED',
        status: 'red-disabled',
      },
      'GroupDisabled': {
        className: 'red_status',
        tooltip: 'TARGETS_STATUS_DISABLED_GROUP',
        status: 'red-disabled',
      },
      'BuyerConcurrencyHit': {
        className: 'yellow_status',
        tooltip: 'BUYERS_STATUS_CC_HIT',
        status: 'capped',
      },
      'BuyerIsCapped': {
        className: 'yellow_status',
        tooltip: 'BUYERS_STATUS_CAPPED',
        status: 'capped',
      },
    };

    const service = {
      createTargetGroup: createTargetGroup,
      getTargetGroupReferences: getTargetGroupReferences,
      deleteTargetGroup: deleteTargetGroup,
      getTargetGroup: getTargetGroup,
      getTargetGroups: getTargetGroups,
      updateTargetGroup: updateTargetGroup,
      updateTargetGroupProperty: updateTargetGroupProperty,
      removeTarget: removeTarget,
      updateTargets: updateTargets,
      addTarget: addTarget,
      resetCallCounters: resetCallCounters,

      defaultColumns: defaultColumns,
      columnSettings: columnSettings
    };
    return service;

    function getTargetGroups(accountId, getStats, updateStatsObj, removeStatsIfDisabled) {
      const url = serviceBaseUri + accountId + '/targetgroups';
      let params = {};
      if (getStats) {
        params = { includeStats: true };
      }
      return $http({
        url: url,
        method: 'GET',
        params: params
      }).then(function handleTargetGroupResponse(response) {
        let targetGroups;
        if (updateStatsObj) {
          targetGroups = updateStatsObj.targetGroups;
        } else {
          targetGroups = response.data.targetGroups;
        }

        targetGroups = _.map(targetGroups, function(targetGroup) {
          return _transformConcurrencyMatrix(targetGroup);
        });
        if (getStats) {
          statsService.normalizeStats(targetGroups, response.data.stats, response.data.caps, blockReasonTranslation);
        }
        if (removeStatsIfDisabled) {
          targetGroups = _.map(targetGroups, function (targetGroup) {
            return _removeStatsIfDisabled(targetGroup);
          });
        }
        response.data.targetGroups = targetGroups;
        return response;
      }, function () {
        return { data: { targetGroups: [] } };
      });
    }

    function getTargetGroup(accountId, targetGroupId) {
      const url = _serviceBaseUrl(accountId, targetGroupId);
      return $http.get(url).then(_transformConcurrencyMatrixFromResponse);
    }

    function createTargetGroup(accountId, targetGroup) {
      const data = _sanitizeTargetGroup(targetGroup);
      const url = serviceBaseUri + accountId + '/targetgroups';
      return $http.post(url, data).then(_transformConcurrencyMatrixFromResponse);
    }

    function getTargetGroupReferences(accountId, targetGroupId) {
      const url = _serviceBaseUrl(accountId, targetGroupId) + '/InboundReferences';
      return $http.get(url);
    }

    function deleteTargetGroup(accountId, targetGroupId, forceUnlink) {
      const url = _serviceBaseUrl(accountId, targetGroupId) + '?force=' + !!forceUnlink;
      return $http.delete(url);
    }

    function updateTargetGroup(accountId, targetGroup) {
      const data = _sanitizeTargetGroup(targetGroup);
      const url = _serviceBaseUrl(accountId, targetGroup.id);
      return $http.patch(url, data).then(_transformConcurrencyMatrixFromResponse);
    }

    function updateTargetGroupProperty(accountId, targetGroupId, item) {
      const url = _serviceBaseUrl(accountId, targetGroupId);
      return $http.patch(url, item);
    }

    function addTarget(accountId, targetGroupId, targetId) {
      const url = _serviceBaseUrl(accountId, targetGroupId) + '/targets';
      const data = { targetId: targetId };
      return $http.patch(url, data);
    }

    function removeTarget(accountId, targetGroupId, targetId) {
      const url = _serviceBaseUrl(accountId, targetGroupId) + '/targets/' + targetId;
      return $http.delete(url);
    }

    function updateTargets(accountId, targetGroupId, { targetAddIds, targetRemoveIds, ringTreeTargetAddIds, ringTreeTargetRemoveIds }) {
      const url = _serviceBaseUrl(accountId, targetGroupId) + '/targets/bulkUpdate';
      const data = {
        targetAddIds,
        targetRemoveIds,
        ringTreeTargetAddIds,
        ringTreeTargetRemoveIds
      };
      return $http.patch(url, data);
    }

    function resetCallCounters(accountId, targetGroupId) {
      const url = _serviceBaseUrl(accountId, targetGroupId) + '/resetcount';
      return $http.delete(url);
    }

    function _serviceBaseUrl(accountId, targetGroupId) {
      return serviceBaseUri + accountId + '/targetgroups/' + targetGroupId;
    }

    function _sanitizeTargetGroup(targetGroup) {
      const sanitized = { id: targetGroup.id };

      if (Object.hasOwn(targetGroup, 'name')) { sanitized.name = targetGroup.name; }
      if (Object.hasOwn(targetGroup, 'enabled')) { sanitized.enabled = targetGroup.enabled; }
      if (Object.hasOwn(targetGroup, 'isSimalDial')) { sanitized.isSimalDial = targetGroup.isSimalDial; }
      if (Object.hasOwn(targetGroup, 'oSchedule')) { sanitized.oSchedule = targetGroup.oSchedule; }
      if (Object.hasOwn(targetGroup, 'oCapacity')) { sanitized.oCapacity = targetGroup.oCapacity; }
      if (Object.hasOwn(targetGroup, 'oConcurrency')) { sanitized.oConcurrency = targetGroup.oConcurrency; }
      if (Object.hasOwn(targetGroup, 'schedule')) { sanitized.schedule = angular.copy(targetGroup.schedule); }
      if (Object.hasOwn(targetGroup, 'disableTargets')) { sanitized.disableTargets = targetGroup.disableTargets; }
      if (typeof targetGroup.schedule !== 'undefined' && targetGroup.schedule.callConcurrencyMatrix) {
        sanitized.schedule.callConcurrencyMatrix = concurrencyMatrixService.postProcessMatrix(sanitized.schedule.callConcurrencyMatrix);
      }
      if (typeof targetGroup.schedule !== 'undefined' && targetGroup.schedule.callCapMatrix) {
        sanitized.schedule.callCapMatrix = concurrencyMatrixService.postProcessMatrix(sanitized.schedule.callCapMatrix);
      }
      return sanitized;
    }

    function _transformConcurrencyMatrixFromResponse(response){
      const targetGroup = response.data.targetGroup;
      return _transformConcurrencyMatrix(targetGroup);
    }

    function _transformConcurrencyMatrix(targetGroup){
      if (targetGroup.schedule.callConcurrencyMatrix) {
        targetGroup.schedule.callConcurrencyMatrix = concurrencyMatrixService.getProcessMatrix(targetGroup.schedule.callConcurrencyMatrix);
      }
      return targetGroup;
    }

    function _removeStatsIfDisabled(targetGroup) {
      const isConcOverrideActive = targetGroup.oConcurrency.globalOverride || targetGroup.oConcurrency.campaignOverride;
      const isCapOverrideActive = targetGroup.oCapacity.globalOverride || targetGroup.oCapacity.campaignOverride;
      targetGroup.caps = {
        live: isConcOverrideActive ? targetGroup.caps.live : -1,
        hour: isCapOverrideActive ? targetGroup.caps.hour : -1,
        day: isCapOverrideActive ? targetGroup.caps.day : -1,
        month: isCapOverrideActive ? targetGroup.caps.month : -1,
        total: isCapOverrideActive ? targetGroup.caps.total : -1,
      };
      return targetGroup;
    }
  }
})();
